import { MapPin, Navigation } from "lucide-react";

// Pulls the arena name + address from the scraped PBJ listing and shows it with
// a one-tap "Get directions" (Google Maps) link.
export function arenaInfo(pbj) {
  const p = (pbj && pbj.listing && pbj.listing.parsed) || {};
  const name = p.arena || null;
  const address = p.arena_address || null;
  const location = p.location || [p.city, p.state].filter(Boolean).join(", ") || null;
  if (!name && !address) return null;
  return { name, address, location };
}

export function ArenaCard({ pbj, dark = false, className = "" }) {
  const a = arenaInfo(pbj);
  if (!a) return null;
  const query = [a.name, a.address, a.location].filter(Boolean).join(", ");
  const maps = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  const box = dark ? "border-white/10 bg-white/5" : "border-[#E4E7EB] bg-[#F8FAFC]";
  const nameCls = dark ? "text-slate-100" : "text-slate-900";
  const subCls = dark ? "text-slate-400" : "text-slate-500";
  const linkCls = dark ? "text-[#F26D77]" : "text-[#C8000F]";
  return (
    <div className={`rounded-md border p-3 ${box} ${className}`} data-testid="arena-card">
      <div className="flex items-start gap-2">
        <MapPin className={`w-4 h-4 mt-0.5 shrink-0 ${linkCls}`} />
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-bold uppercase tracking-wide text-slate-400">Arena</div>
          {a.name && <div className={`text-sm font-bold leading-tight ${nameCls}`} data-testid="arena-name">{a.name}</div>}
          {(a.address || a.location) && (
            <div className={`text-[12px] leading-snug ${subCls}`} data-testid="arena-address">
              {[a.address, a.location].filter(Boolean).join(", ")}
            </div>
          )}
          <a href={maps} target="_blank" rel="noreferrer" data-testid="arena-directions"
            className={`inline-flex items-center gap-1 mt-1.5 text-xs font-semibold ${linkCls} hover:underline`}>
            <Navigation className="w-3.5 h-3.5" /> Get directions
          </a>
        </div>
      </div>
    </div>
  );
}

export default ArenaCard;
